var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000168834880034263361310000015379832728395481266_);}\n\t.st2{fill:url(#SVGID_00000022551777667622435080000000014274917659586959_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.9296,
    y1: 481.4059,
    x2: 238.0705,
    y2: 445.5468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,488.8c14,0,25.4-11.4,25.4-25.4c0-14-11.4-25.4-25.4-25.4s-25.4,11.4-25.4,25.4 C230.6,477.5,242,488.8,256,488.8z M256,451.9c6.4,0,11.5,5.2,11.5,11.5S262.4,475,256,475c-6.4,0-11.5-5.2-11.5-11.5 S249.6,451.9,256,451.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034783435749673505200000012920735004355840903_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.2258,
    y1: 441.2261,
    x2: 70.7742,
    y2: 70.7745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034783435749673505200000012920735004355840903_)"
    },
    d: "M353.6,0H158.4 c-22.5,0-40.8,18.3-40.8,40.8v430.4c0,22.5,18.3,40.8,40.8,40.8h195.2c22.5,0,40.8-18.3,40.8-40.8V40.8C394.4,18.3,376.1,0,353.6,0 z M380.5,471.2c0,14.9-12.1,27-27,27H158.4c-14.9,0-27-12.1-27-27v-46.4h249.1V471.2z M380.5,411H131.5l0-337.9h249.1V411z  M380.5,59.3H131.5V40.8c0-14.9,12.1-27,27-27h195.2c14.9,0,27,12.1,27,27V59.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158023122035740297190000005574763431380181910_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.6488,
    y1: 61.26,
    x2: 230.3505,
    y2: 9.9617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158023122035740297190000005574763431380181910_)"
    },
    d: "M297.5,28.7h-83c-3.8,0-6.9,3.1-6.9,6.9 c0,3.8,3.1,6.9,6.9,6.9h83c3.8,0,6.9-3.1,6.9-6.9C304.4,31.8,301.3,28.7,297.5,28.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphones);
export default __webpack_public_path__ + "static/media/smartphones.f25206abfa439c30cb4fd9a6c010132f.svg";
export { ForwardRef as ReactComponent };